import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import LogoSmallScreen from '../logo.png';

const Navbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState({});

  const toggleDropdown = (key) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const closeDropdown = (key) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [key]: false,
    }));
  };

  return (
    <nav className='navbar navbar-expand-lg sticky-top bg-custom-light px-3 py-2'>
      <div className='container-fluid'>
        <NavLink to='/' className='navbar-brand d-flex align-items-center'>
          <img 
            src={LogoSmallScreen} 
            alt='WeFlare Logo' 
            height='60px' 
            width='55px'
            className="me-2"
            style={{filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'}}
          />
          <span className="text1 text-primary d-none d-md-inline" style={{fontSize: '1.5rem'}}>
            WeFlare
          </span>
        </NavLink>

        {/* Modern Toggle Button */}
        <button 
          className='navbar-toggler border-0 p-2' 
          type='button' 
          data-bs-toggle='collapse' 
          data-bs-target='#navbarNav' 
          aria-controls='navbarNav' 
          aria-expanded='false' 
          aria-label='Toggle navigation'
          style={{boxShadow: 'none'}}
        >
          <div className="navbar-toggler-icon-modern">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>

        {/* Navigation Menu */}
        <div className='collapse navbar-collapse' id='navbarNav'>
          <div className='navbar-nav ms-auto align-items-lg-center'>
            <NavLink 
              to='/' 
              className='nav-link text2 text-primary fw-semibold px-3 py-2 rounded-pill mx-1'
              style={{transition: 'all 0.3s ease'}}
            >
              Home
            </NavLink>
            
            {/* About Us Dropdown */}
            <div
              className="nav-item dropdown mx-1 position-relative"
            >
              <NavLink
                to="#"
                className="nav-link text2 text-primary fw-semibold px-3 py-2 rounded-pill d-flex align-items-center dropdown-toggle-custom"
                role="button"
                style={{transition: 'all 0.3s ease'}}
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown('aboutUs');
                }}
                onMouseEnter={() => toggleDropdown('aboutUs')}
              >
                About Us
                <i className="bi bi-chevron-down ms-1 small"></i>
              </NavLink>
              {dropdownOpen.aboutUs && (
                <div 
                  className="dropdown-menu custom-dropdown border-0 show position-absolute"
                  onMouseLeave={() => closeDropdown('aboutUs')}
                >
                  <NavLink 
                    to="/about-us/who-we-are" 
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => closeDropdown('aboutUs')}
                  >
                    <i className="bi bi-info-circle me-2 text-primary"></i>
                    Who We Are
                  </NavLink>
                  <NavLink 
                    to="/about-us/team" 
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => closeDropdown('aboutUs')}
                  >
                    <i className="bi bi-people me-2 text-primary"></i>
                    Our Team
                  </NavLink>
                  <NavLink
                      to="/gallery"
                      className="dropdown-item d-flex align-items-center"
                      onClick={() => closeDropdown('aboutUs')}
                  >
                    <i className="bi bi-camera me-2 text-primary"></i>
                    Gallery
                  </NavLink>
                </div>
              )}
            </div>

            {/* Programs Dropdown */}
            <div
              className="nav-item dropdown mx-1 position-relative"
            >
              <NavLink
                to="#"
                className="nav-link text2 text-primary fw-semibold px-3 py-2 rounded-pill d-flex align-items-center dropdown-toggle-custom"
                role="button"
                style={{transition: 'all 0.3s ease'}}
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown('programs');
                }}
                onMouseEnter={() => toggleDropdown('programs')}
              >
                Programs
                <i className="bi bi-chevron-down ms-1 small"></i>
              </NavLink>
              {dropdownOpen.programs && (
                <div 
                  className="dropdown-menu custom-dropdown border-0 show position-absolute"
                  onMouseLeave={() => closeDropdown('programs')}
                >
                  <NavLink 
                    to="/programs/overview" 
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => closeDropdown('programs')}
                  >
                    <i className="bi bi-grid me-2 text-primary"></i>
                    Overview
                  </NavLink>
                  <NavLink 
                    to="/programs/learn-coding" 
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => closeDropdown('programs')}
                  >
                    <i className="bi bi-code-slash me-2 text-primary"></i>
                    Learn Coding
                  </NavLink>
                  <NavLink 
                    to="/programs/youth-leadership-and-mentorship" 
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => closeDropdown('programs')}
                  >
                    <i className="bi bi-award me-2 text-primary"></i>
                    Youth Leadership
                  </NavLink>
                </div>
              )}
            </div>

            {/* <NavLink 
              to='/blog' 
              className='nav-link text2 text-primary fw-semibold px-3 py-2 rounded-pill mx-1'
              style={{transition: 'all 0.3s ease'}}
            >
              Blog
            </NavLink> */}

            <NavLink 
              to='/privacy' 
              className='nav-link text2 text-primary fw-semibold px-3 py-2 rounded-pill mx-1'
              style={{transition: 'all 0.3s ease'}}
            >
              Privacy
            </NavLink>

            {/* Donation Button */}
            <div className="nav-item ms-2">
              <NavLink 
                to="/donate" 
                className="btn-modern btn-outline btn-sm me-2"
                style={{fontSize: '0.875rem', padding: '0.5rem 1.25rem'}}
              >
                <i className="bi bi-heart me-1"></i>
                Donate
              </NavLink>
            </div>

            {/* Contact CTA Button */}
            <div className="nav-item">
              <NavLink 
                to="/#contact" 
                className="btn-modern btn-primary btn-sm"
                style={{fontSize: '0.875rem', padding: '0.5rem 1.25rem'}}
                onClick={(e) => {
                  // If we're already on the home page, scroll to contact
                  if (window.location.pathname === '/') {
                    e.preventDefault();
                    const contactSection = document.getElementById('contact');
                    if (contactSection) {
                      contactSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }
                  // If we're on another page, let React Router handle navigation to home
                }}
              >
                <i className="bi bi-envelope me-1"></i>
                Contact Us
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
